import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';

import { Actividad } from '../models/actividad';
import { ActividadService } from '../services/actividad.service';
@Component({
  selector: 'app-actividad',
  templateUrl: './actividad.component.html',
  styleUrls: ['./actividad.component.css']
})
export class ActividadComponent implements OnInit {

  model: Actividad = new Actividad();
  url = environment.imgUrl;

  constructor(private modelService: ActividadService, private route: ActivatedRoute) {
    this.model.id = Number(this.route.snapshot.paramMap.get('id'));
  }

  ngOnInit() {
    this.modelService.get(this.model.id).subscribe(val => {
      this.model = val;
    });
  }

}
